import styled from 'styled-components';

export const DetailHeader = styled.div`
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    background: var(--gray-1);
`;

export const BackButton = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
`;

export const DetailTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const DetailsTable = styled.div`
    margin-bottom: 24px;
`;

export const DetailRow = styled.div`
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid var(--gray-4);
    font-size: 14px;
    line-height: 22px;
`;

export const DetailLabel = styled.span`
    width: 38%;
    flex-shrink: 0;
    color: var(--gray-7);
`;

export const DetailValue = styled.span`
    color: var(--gray-10);
    word-break: break-word;
`;

export const InfoSection = styled.div`
    margin-top: 20px;
`;

export const InfoTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 600;
    color: var(--gray-10);
`;

export const InfoBody = styled.p`
    font-size: 14px;
    line-height: 22px;
    color: var(--gray-8);
    margin: 0;
`;

export const InfoLink = styled.a`
    color: var(--blue-6, #1890ff);
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const MetadataList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const MetadataRow = styled.li`
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 16px;
    line-height: 22px;
    padding: 4px 0;
    align-items: center;

    &:not(:last-child) {
        border-bottom: 1px solid var(--gray-3);
    }
`;

export const MetadataKey = styled.span`
    color: rgba(0, 0, 0, 0.65);
`;

export const ConsignmentList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    gap: 16px;
`;

export const ConsignmentRow = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
`;

export const ConsignmentName = styled.strong`
    display: block;
    font-weight: 600;
    line-height: 22px;
    color: var(--gray-10);
`;

export const ConsignmentId = styled.span`
    display: block;
    line-height: 22px;
    color: var(--gray-8);
    word-break: break-word;
`;

export const MetadataValue = styled.strong`
    min-width: 0;
    font-weight: 600;
    color: var(--gray-9);
    word-break: break-word;
`;
